import { createStore } from "./_createStore";

type GlobalNavState = {
  isViewingArchivedWorkOrder: boolean;
  setIsViewingArchivedWorkOrder: (value: boolean) => void;
};

export const useGlobalNavStore = createStore<GlobalNavState>(
  (set) => ({
    isViewingArchivedWorkOrder: false,
    setIsViewingArchivedWorkOrder: (value) =>
      set({ isViewingArchivedWorkOrder: value }),
  }),
  "GlobalNavStore",
);
